module.exports = __webpack_public_path__ + "img/venus2.b934c44f.png";